import { openAppAdvertisementOverlay } from 'frontend/unpoly/javascripts/modules/show_app_advertisement'
import { openAppRatingOverlay } from 'frontend/unpoly/javascripts/modules/show_app_rating'
import {
  createLearningReminders,
  type LearningRemindersData,
} from 'frontend/shared/javascripts/modules/learning_reminders'
import type { CompilerMeta } from 'types/unpoly/compiler'

const remind = createLearningReminders()

interface LearningRemindersElementData extends Omit<LearningRemindersData, 'appRating'> {
  advertisement_modal_path: string
  app_rating_modal_path?: string
}

up.compiler(
  '[data-learning-reminders]',
  { priority: 1 },
  (element: HTMLElement, data: LearningRemindersElementData, meta: CompilerMeta) => {
    if (!meta.layer.isRoot()) {
      return
    }

    if (meta.revalidating) {
      return
    }

    if (up.layer.isOverlay() && !window._gdpr_testModalOpen) {
      // When rendering inside a modal, we do not want to update the layout used in the background.
      return
    }

    return remind(
      { ...data, appRating: !!data.app_rating_modal_path },
      {
        openAppRating: () => openAppRatingOverlay(data.app_rating_modal_path!),
        openAppAdvertisement: () => openAppAdvertisementOverlay(data.advertisement_modal_path),
      },
    )
  },
)
